import DateFormatter from '../../shared/utils/DateFormatter';
import { PsUser } from '../shared/model/PsUser';
import { PsWork } from '../shared/model/PsWork';
import { PsWorker } from '../shared/model/PsWorker';
import { PsCompany } from '../shared/model/PsCompany';
import { PsMachine } from '../shared/model/PsMachine';
import { PsDocument } from '../shared/model/PsDocument';
import { PsOrigin } from '../shared/model/PsOrigin';

export class PsMessage {

    _id; // number
    _date; // Date
    _read; // boolean
    _body; // string

    _user = null; // PsUser | null
    _work = null; // PsWork | null
    _worker = null; // PsWorker | null
    _company = null; // PsCompany | null
    _machine = null; // PsMachine | null
    _document = null; // PsDocument | null
    _replyMessages = [];
    _active = false; // boolean

    constructor(
        id,
        date,
        read,
        body,
    ) {
        this._id = id;
        this._date = date;
        this._read = read;
        this._body = body;
    }

    static fromAPIMessages(messages) {
        return messages.map((message) => PsMessage.fromAPIMessage(message));
    }

    static fromAPIMessage(message) {
        const {
            id,
            date,
            is_read,
            message: messageBody,
            source_user,
            company,
            construction,
            worker,
            machine,
            document,
            children,
            active,
        } = message;

        const psMessage = new this(
            id,
            date,
            is_read,
            messageBody,
        );


        psMessage._active = active;

        if ( source_user ) {
            psMessage._user = PsUser.fromAPIUser(source_user);
        }

        if ( company ) {
            psMessage._company = PsCompany.fromAPICompany(company);

            if ( construction ) {
                psMessage._work = PsWork.fromAPIWork(construction);
            }

            if ( worker ) {
                psMessage._worker = PsWorker.fromAPIWorker(worker);
                psMessage._worker.assignCompany(psMessage._company);
                psMessage._worker.assignOrigin(
                    PsOrigin.fromValues(
                        {
                            companyId: psMessage._company.id(),
                            workerId: psMessage._worker.id(),
                            fromMyContractors: worker.as_subcontracted,
                        },
                    ),
                );
            }

            if ( machine ) {
                psMessage._machine = PsMachine.fromAPIMachine(machine);
                psMessage._machine.assignCompany(psMessage._company);
                psMessage._machine.assignOrigin(
                    PsOrigin.fromValues(
                        {
                            companyId: psMessage._company.id(),
                            machineId: psMessage._machine.id(),
                            fromMyContractors: machine.as_subcontracted,
                        },
                    ),
                );
            }

            if ( document ) {
                psMessage._document = PsDocument.fromAPIDocument(document);
                if ( document.worker ) {
                    psMessage._worker = PsWorker.fromAPIWorker(document.worker);
                    psMessage._worker.assignCompany(psMessage._company);
                    psMessage._worker.assignOrigin(
                        PsOrigin.fromValues(
                            {
                                companyId: psMessage._company.id(),
                                workerId: psMessage._worker.id(),
                                fromMyContractors: document.as_subcontracted,
                            },
                        ),
                    );
                }

                if ( document.machine ) {
                    psMessage._machine = PsMachine.fromAPIMachine(document.machine);
                    psMessage._machine.assignCompany(psMessage._company);
                    psMessage._machine.assignOrigin(
                        PsOrigin.fromValues(
                            {
                                companyId: psMessage._company.id(),
                                machineId: psMessage._machine.id(),
                                fromMyContractors: document.as_subcontracted,
                            },
                        ),
                    );
                }

                psMessage._document.assignOrigin(
                    PsOrigin.fromValues(
                        {
                            companyId: psMessage._company.id(),
                            workerId: document.worker ? document.worker.id : undefined,
                            machineId: document.machine ? document.machine.id : undefined,
                            documentId: document.id,
                            fromMyContractors: document.as_subcontracted,
                        },
                    ),
                );
            }
        }

        if ( children && children.length !== 0 ) {
            psMessage._replyMessages = PsMessage.fromAPIMessages(children);
        }

        return psMessage;
    }

    id() {
        return this._id;
    }

    title() {
        return this.hasUser() ? this.user().completeName() : '';
    }

    date() {
        return this._date;
    }

    isRead() {
        return this._read;
    }

    body() {
        return this._body;
    }

    dateDescription() {
        return DateFormatter.formatDatetime(this.date());
    }

    user() {
        return this._user;
    }

    userAvatar() {
        return this.hasUser() ? this.user().avatar() : '';
    }

    hasUser() {
        return !!this.user();
    }

    work() {
        return this._work;
    }

    hasWork() {
        return !!this.work();
    }

    worker() {
        return this._worker;
    }

    hasWorker() {
        return !!this.worker();
    }

    company() {
        return this._company;
    }

    hasCompany() {
        return !!this.company();
    }

    machine() {
        return this._machine;
    }

    hasMachine() {
        return !!this.machine();
    }

    document() {
        return this._document;
    }

    hasDocument() {
        return !!this.document();
    }

    replyMessages() {
        return this._replyMessages;
    }

    active() {
        return this._active;
    }
}



// WEBPACK FOOTER //
// ./src/app/messages-notifications/messages/PsMessage.js